import { aboutContent } from '@/mocks/homeData';

export default function About() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">
              {aboutContent.title}
            </h2>
          </div>

          <div className="bg-background-50 rounded-2xl p-6 md:p-10">
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
              {aboutContent.desc}
            </p>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-6">
              {aboutContent.stats.map((stat) => (
                <div
                  key={stat.label}
                  className="text-center p-4 rounded-xl bg-background-100"
                >
                  <div className="font-heading text-2xl md:text-3xl text-primary-600 mb-1">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-foreground-500">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}